import { render } from "./LaborByService.vue?vue&type=template&id=4de9a398"
import script from "./LaborByService.vue?vue&type=script&lang=js"
export * from "./LaborByService.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__